import { ApiError } from './api';

/**
 * Messages de l'écran des congés pour les refus de l'API, par code (et non par
 * texte, que l'API peut reformuler) : formulation pour l'utilisateur, sans
 * jargon (pas de « traitant du client 3 »).
 */
const CONGES_MESSAGES: Record<string, string> = {
  SUBSTITUTE_NOT_DT: "Ce substitut n'est pas un agent Digital Team.",
  NOT_DT_AGENT: "Ce compte n'est pas un agent Digital Team : il ne peut pas avoir de substitut.",
};

/** Champ `code` du corps d'erreur de l'API, s'il est présent (sans cast). */
function errorCode(payload: unknown): string | undefined {
  if (!payload || typeof payload !== 'object' || !('code' in payload)) return undefined;
  const { code } = payload;
  return typeof code === 'string' ? code : undefined;
}

export function congesErrorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    const code = errorCode(e.body);
    const msg = code ? CONGES_MESSAGES[code] : undefined;
    if (msg) return msg;
  }
  return e instanceof Error ? e.message : 'Erreur';
}
